/* eslint-disable indent */
import React, { useState } from 'react'
import axios from 'axios'
import { Card, Form, Button, Row, Col, Table } from 'react-bootstrap'
import { skills, taidot, translations } from '../services/arrays'
import { getTranslation } from '../services/translations'

const TrainButton = ({ player, lang = 'fi' }) => {
  const t = key => getTranslation(lang, key)
  const defaultMode = Number(player?.trainingData?.mode || 7)
  const defaultSkillKey = skills[defaultMode - 2] || 'playmakerSkill'
  const defaultLevel = Number(player?.playerSkills?.[defaultSkillKey] || 0)

  const initialFormData = {
    coach: player.trainingData ? player.trainingData.coach : '5',
    assistants: player.trainingData ? player.trainingData.assistants : '10',
    intensity: player.trainingData ? player.trainingData.intensitety : '100',
    stamina: player.trainingData ? player.trainingData.stamina : '10',
    mode: player.trainingData ? player.trainingData.mode : String(defaultMode),
    minutes: player.trainingData ? player.trainingData.minutes : '90',
    efficiency: player.trainingData ? player.trainingData.effency : '1',
    lvl: defaultLevel,
    age: player.age,
    sessions: '1',
    playerStamina: player.playerSkills?.staminaSkill || '5',
    targetStamina: '', // Kestävyyden tavoitetaso (valinnainen)
  }

  const [formData, setFormData] = useState(initialFormData)
  const [subLevelResult, setSubLevelResult] = useState(null)
  const [staminaResult, setStaminaResult] = useState(null)
  const [allWeeksData, setAllWeeksData] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [lastTrainingMode, setLastTrainingMode] = useState(null)
  const [calculateAge, setCalculateAge] = useState(
    `${player.age}.${player.ageDays}`
  )
  const [subLevelSessions, setSubLevelSessions] = useState('1')
  const [subLevelMinutes, setSubLevelMinutes] = useState(
    player.trainingData ? player.trainingData.minutes : '90'
  )
  const language = lang === 'en' ? 1 : 0

  const handleChange = e => {
    const { name, value } = e.target

    setFormData(prevData => {
      let updatedValue = value.replace(',', '.')

      if (name === 'mode') {
        // Muutetaan alasvetovalikosta saatu tekstiarvo numeroksi
        updatedValue = parseInt(updatedValue)
        console.log(updatedValue)

        // Jos jatketaan suunnitelmaa, haetaan uusi taito pelaajan tiedoista
        const newSkillKey = skills[updatedValue - 2] || 'playmakerSkill'
        const newSkillLevel = Number(player.playerSkills[newSkillKey] || 0)

        return {
          ...prevData,
          mode: updatedValue,
          lvl: newSkillLevel,
        }
      }

      return {
        ...prevData,
        [name]: updatedValue,
      }
    })
  }

  const handleCalculateSubLevel = async () => {
    if (Number(formData.efficiency) > 1.25) {
      setErrorMessage(t('maxEfficiency') || 'Teho voi olla maksimissaan 1.25')
      return
    }
    setErrorMessage('')

    try {
      const response = await axios.post(
        '/api/players/calculate-current-sublevel',
        {
          sessions: Number(subLevelSessions),
          level: Number.isInteger(Number(formData.lvl))
            ? Number(formData.lvl) + 1
            : Math.ceil(Number(formData.lvl)),
          coach: Number(formData.coach),
          assistants: Number(formData.assistants),
          intensity: Number(formData.intensity),
          stamina: Number(formData.stamina),
          mode: Number(formData.mode) - 1,
          age: [player.age, player.ageDays],
          minutes: Number(subLevelMinutes),
          efficiency: Number(formData.efficiency),
        }
      )

      setSubLevelResult(response.data.currentSubLevel)
    } catch (error) {
      console.error('Virhe alatason laskemisessa:', error)
    }
  }

  const handleTrainingSubmit = async e => {
    e.preventDefault()

    const {
      lvl,
      coach,
      assistants,
      intensity,
      stamina,
      mode,
      minutes,
      efficiency,
      sessions,
      playerStamina,
      targetStamina,
    } = formData

    // Validoi teho
    if (Number(efficiency) > 1.25) {
      setErrorMessage('Teho voi olla maksimissaan 1.25')
      return
    }
    setErrorMessage('')

    // Validoi kestävyyden osuus (10-99)
    if (Number(stamina) < 10 || Number(stamina) > 99) {
      setErrorMessage('Kestävyyden osuus voi olla 10-99')
      return
    }

    // Ensimmäinen laskenta - käytä calculateAge
    const ageParts = calculateAge.split('.')
    const ageYears = Number(ageParts[0]) || player.age
    const ageDays = Number(ageParts[1]) || player.ageDays

    // Laske sekä taidon että kestävyyden muutos yhdellä kutsulla
    try {
      const response = await axios.post('/api/players/stamina-training', {
        currentStamina: Number(playerStamina),
        age: [ageYears, ageDays],
        staminaShare: Number(stamina),
        intensity: Number(intensity),
        sessions: Number(sessions),
        currentLevel: Number(lvl),
        coach: Number(coach),
        assistants: Number(assistants),
        mode: Number(mode),
        minutes: Number(minutes),
        efficiency: Number(efficiency),
        startWeek: 0,
        targetStamina: targetStamina ? Number(targetStamina) : null,
      })

      setStaminaResult(response.data)

      // Ensimmäinen laskenta - korvaa taulukko
      setAllWeeksData(response.data.weeklyProgress)
      // Tallenna treenimuoto jatkamista varten
      setLastTrainingMode(Number(mode))
    } catch (error) {
      console.error('Virhe laskennassa:', error)
      setStaminaResult(null)
    }
  }

  // Jatka suunnitelmaa -funktio - lähettää heti pyynnön backendille
  const handleContinuePlan = async () => {
    if (allWeeksData.length === 0) return

    const lastWeek = allWeeksData[allWeeksData.length - 1]
    const {
      coach,
      assistants,
      intensity,
      stamina,
      mode,
      minutes,
      efficiency,
      sessions,
      targetStamina,
    } = formData

    // Validoi teho
    if (Number(efficiency) > 1.25) {
      setErrorMessage('Teho voi olla maksimissaan 1.25')
      return
    }
    setErrorMessage('')

    // Validoi kestävyyden osuus (10-99)
    if (Number(stamina) < 10 || Number(stamina) > 99) {
      setErrorMessage('Kestävyyden osuus voi olla 10-99')
      return
    }

    // Käytä viimeisen viikon ikää ja arvoja
    let ageYears = lastWeek.age[0]
    let ageDays = lastWeek.age[1]
    // Lisää 7 päivää seuraavaa viikkoa varten
    ageDays += 7
    if (ageDays >= 112) {
      ageYears += 1
      ageDays = ageDays % 112
    }
    const startWeek = lastWeek.week

    // Taitotaso: jos mode on vaihtunut, käytä pelaajan tietoja, muuten taulukon arvoa
    let skillLevel
    if (lastTrainingMode !== null && Number(mode) !== lastTrainingMode) {
      // Mode vaihtunut - hae pelaajan taito
      skillLevel = player.playerSkills[skills[Number(mode) - 2]] || 0
    } else {
      // Sama mode - jatka taulukon arvosta
      skillLevel = lastWeek.skillAfter
    }
    const staminaLevel = lastWeek.staminaAfter

    try {
      const response = await axios.post('/api/players/stamina-training', {
        currentStamina: Number(staminaLevel),
        age: [ageYears, ageDays],
        staminaShare: Number(stamina),
        intensity: Number(intensity),
        sessions: Number(sessions),
        currentLevel: Number(skillLevel),
        coach: Number(coach),
        assistants: Number(assistants),
        mode: Number(mode),
        minutes: Number(minutes),
        efficiency: Number(efficiency),
        startWeek: startWeek,
        targetStamina: targetStamina ? Number(targetStamina) : null,
      })

      setStaminaResult(response.data)

      // Lisää uudet viikot allWeeksData:an
      setAllWeeksData(prev => [...prev, ...response.data.weeklyProgress])
      // Päivitä treenimuoto
      setLastTrainingMode(Number(mode))
    } catch (error) {
      console.error('Virhe laskennassa:', error)
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error)
      }
    }
  }

  const handleReset = () => {
    setStaminaResult(null)
    setAllWeeksData([])
    setLastTrainingMode(null)
    setErrorMessage('')
  }

  const formGroupStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.35rem',
  }
  const labelStyle = {
    flex: '1 1 auto',
    marginRight: '0.25rem',
    marginBottom: 0,
    fontSize: '0.8rem',
    whiteSpace: 'nowrap',
  }
  const inputStyle = {
    backgroundColor: '#1E2124',
    color: '#FFFFFF',
    fontSize: '0.8rem',
    width: '100px',
    minWidth: '100px',
    flex: '0 0 100px',
  }

  return (
    <Card
      className="mb-3"
      style={{
        backgroundColor: '#2C2F33',
        color: '#FFFFFF',
        borderColor: '#1E2124',
      }}
    >
      <Card.Header
        style={{
          backgroundColor: '#1a1d21',
          color: '#FFFFFF',
          fontSize: '0.8rem',
          padding: '6px 12px',
        }}
      >
        {t('trainingCalculator')}
      </Card.Header>
      <Card.Body>
        <Row>
          {/* Kortti 1: Laskennan lähtötiedot */}
          <Col md={6} xl={4} className="d-flex">
            <Card
              className="w-100"
              style={{
                backgroundColor: '#23272A',
                color: '#FFFFFF',
                borderColor: '#1E2124',
                fontSize: '0.8rem',
              }}
            >
              <Card.Header
                style={{
                  backgroundColor: '#1a1d21',
                  color: '#FFFFFF',
                  fontSize: '0.8rem',
                  padding: '6px 12px',
                }}
              >
                {t('calculationInputs')}
              </Card.Header>
              <Card.Body style={{ padding: '8px 10px' }}>
                {[
                  'mode',
                  'coach',
                  'assistants',
                  'intensity',
                  'stamina',
                  'minutes',
                  'efficiency',
                ].map((field, index) => (
                  <Form.Group
                    controlId={`form${field}`}
                    key={index}
                    style={formGroupStyle}
                  >
                    <Form.Label style={labelStyle}>
                      {translations[field][language]}
                      {(field === 'intensity' || field === 'stamina') && ' %'}:
                    </Form.Label>
                    {field === 'mode' ? (
                      <Form.Control
                        as="select"
                        name={field}
                        value={formData[field]}
                        onChange={handleChange}
                        size="sm"
                        style={inputStyle}
                      >
                        {taidot.map((skill, idx) => (
                          <option key={idx} value={idx + 2}>
                            {skill}
                          </option>
                        ))}
                      </Form.Control>
                    ) : (
                      <Form.Control
                        type="text"
                        name={field}
                        value={formData[field]}
                        onChange={handleChange}
                        size="sm"
                        style={inputStyle}
                      />
                    )}
                  </Form.Group>
                ))}
                <Form.Group style={formGroupStyle}>
                  <Form.Label style={labelStyle}>
                    {t('ageInCalculation')}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={calculateAge}
                    onChange={e => setCalculateAge(e.target.value)}
                    size="sm"
                    style={inputStyle}
                  />
                </Form.Group>
                <Form.Group style={formGroupStyle}>
                  <Form.Label style={labelStyle}>
                    {t('playerStaminaLabel')}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="playerStamina"
                    value={formData.playerStamina}
                    onChange={handleChange}
                    size="sm"
                    style={inputStyle}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>

          {/* Kortti 2: Harjoittelulaskuri */}
          <Col md={6} xl={4} className="d-flex">
            <Card
              className="w-100"
              style={{
                backgroundColor: '#23272A',
                color: '#FFFFFF',
                borderColor: '#1E2124',
                fontSize: '0.8rem',
              }}
            >
              <Card.Header
                style={{
                  backgroundColor: '#1a1d21',
                  color: '#FFFFFF',
                  fontSize: '0.8rem',
                  padding: '6px 12px',
                }}
              >
                {t('trainingCalculator')}
              </Card.Header>
              <Card.Body style={{ padding: '8px 10px' }}>
                <Form.Group
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0.35rem',
                  }}
                >
                  <Form.Label
                    style={{
                      width: '50%',
                      marginRight: '0.25rem',
                      marginBottom: 0,
                      fontSize: '0.8rem',
                    }}
                  >
                    {t('weeks')}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="sessions"
                    value={formData.sessions}
                    onChange={handleChange}
                    size="sm"
                    style={{
                      backgroundColor: '#1E2124',
                      color: '#FFFFFF',
                      fontSize: '0.8rem',
                    }}
                  />
                </Form.Group>
                <Form.Group
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0.35rem',
                  }}
                >
                  <Form.Label
                    style={{
                      width: '50%',
                      marginRight: '0.25rem',
                      marginBottom: 0,
                      fontSize: '0.8rem',
                    }}
                  >
                    {t('staminaTarget')}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="targetStamina"
                    value={formData.targetStamina}
                    onChange={handleChange}
                    placeholder=""
                    size="sm"
                    style={{
                      backgroundColor: '#1E2124',
                      color: '#FFFFFF',
                      fontSize: '0.8rem',
                    }}
                  />
                </Form.Group>
                {errorMessage && (
                  <div
                    style={{
                      color: '#f04747',
                      fontSize: '0.8rem',
                      marginBottom: '0.35rem',
                      padding: '4px',
                      backgroundColor: '#2C2F33',
                      borderRadius: '4px',
                    }}
                  >
                    {errorMessage}
                  </div>
                )}
                {allWeeksData.length > 0 && (
                  <Button
                    variant="success"
                    size="sm"
                    onClick={handleContinuePlan}
                    style={{
                      backgroundColor: '#43b581',
                      borderColor: '#43b581',
                      width: '100%',
                      marginTop: '0.5rem',
                    }}
                  >
                    {t('continuePlan')}
                  </Button>
                )}
                {allWeeksData.length === 0 ? (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={e => handleTrainingSubmit(e)}
                    style={{
                      backgroundColor: '#1E2124',
                      borderColor: '#1E2124',
                      width: '100%',
                      marginTop: '0.5rem',
                    }}
                  >
                    {t('send')}
                  </Button>
                ) : (
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={handleReset}
                    style={{
                      backgroundColor: '#72767D',
                      borderColor: '#72767D',
                      width: '100%',
                      marginTop: '0.5rem',
                    }}
                  >
                    {t('reset')}
                  </Button>
                )}

                {/* Yhteenveto */}
                {staminaResult && (
                  <div
                    style={{
                      marginTop: '0.75rem',
                      padding: '6px',
                      backgroundColor: '#1E2124',
                      borderRadius: '4px',
                      fontSize: '0.8rem',
                    }}
                  >
                    <strong>{t('summaryLabel')}:</strong>
                    <br />
                    {t('skillLabel')}: {staminaResult.currentLevel?.toFixed(2)}{' '}
                    → {staminaResult.newLevel?.toFixed(2)} (
                    <span
                      style={{
                        color:
                          staminaResult.skillChange >= 0
                            ? '#43b581'
                            : '#f04747',
                      }}
                    >
                      {staminaResult.skillChange >= 0 ? '+' : ''}
                      {staminaResult.skillChange?.toFixed(2)}
                    </span>
                    )
                    <br />
                    {t('staminaLabel')}:{' '}
                    {staminaResult.currentStamina?.toFixed(2)} →{' '}
                    {staminaResult.newStamina?.toFixed(2)} (
                    <span
                      style={{
                        color:
                          staminaResult.change >= 0 ? '#43b581' : '#f04747',
                      }}
                    >
                      {staminaResult.change >= 0 ? '+' : ''}
                      {staminaResult.change?.toFixed(2)}
                    </span>
                    )
                    <br />
                    {t('finalAge')}: {staminaResult.finalAge?.[0]}v{' '}
                    {staminaResult.finalAge?.[1]}d
                    <br />
                    <span style={{ fontSize: '0.75rem', color: '#99AAB5' }}>
                      {t('equilibrium')}:{' '}
                      {staminaResult.equilibrium?.toFixed(2) || '-'} | Max (
                      {player.age}v): {staminaResult.maxStamina?.toFixed(2)}
                      {staminaResult.usedStaminaShare && (
                        <>
                          {' '}
                          | {t('usedShare')}: {staminaResult.usedStaminaShare}
                        </>
                      )}
                    </span>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* Kortti 3: Alatason laskenta */}
          <Col md={6} xl={4} className="d-flex">
            <Card
              className="w-100"
              style={{
                backgroundColor: '#23272A',
                color: '#FFFFFF',
                borderColor: '#1E2124',
                fontSize: '0.8rem',
              }}
            >
              <Card.Header
                style={{
                  backgroundColor: '#1a1d21',
                  color: '#FFFFFF',
                  fontSize: '0.8rem',
                  padding: '6px 12px',
                }}
              >
                {t('sublevelCalculation')}
              </Card.Header>
              <Card.Body style={{ padding: '8px 10px' }}>
                <div
                  style={{
                    fontSize: '0.7rem',
                    color: '#99AAB5',
                    marginBottom: '0.5rem',
                    lineHeight: '1.3',
                  }}
                >
                  {t('sublevelHelp')}
                </div>
                <Form.Group
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0.35rem',
                  }}
                >
                  <Form.Label
                    style={{
                      width: '50%',
                      marginRight: '0.25rem',
                      marginBottom: 0,
                      fontSize: '0.8rem',
                    }}
                  >
                    {t('trainingSessions')}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={subLevelSessions}
                    onChange={e =>
                      setSubLevelSessions(e.target.value.replace(',', '.'))
                    }
                    size="sm"
                    style={{
                      backgroundColor: '#1E2124',
                      color: '#FFFFFF',
                      fontSize: '0.8rem',
                    }}
                  />
                </Form.Group>
                <Form.Group
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0.35rem',
                  }}
                >
                  <Form.Label
                    style={{
                      width: '50%',
                      marginRight: '0.25rem',
                      marginBottom: 0,
                      fontSize: '0.8rem',
                    }}
                  >
                    {translations['minutes'][language]}:
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={subLevelMinutes}
                    onChange={e =>
                      setSubLevelMinutes(e.target.value.replace(',', '.'))
                    }
                    size="sm"
                    style={{
                      backgroundColor: '#1E2124',
                      color: '#FFFFFF',
                      fontSize: '0.8rem',
                    }}
                  />
                </Form.Group>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={handleCalculateSubLevel}
                  style={{
                    backgroundColor: '#7289DA',
                    borderColor: '#7289DA',
                    width: '100%',
                    marginTop: '0.5rem',
                  }}
                >
                  {t('calculateSublevel')}
                </Button>
                {subLevelResult !== null && (
                  <div style={{ marginTop: '0.75rem' }}>
                    <strong>{t('currentSublevel')}:</strong>{' '}
                    {Number(subLevelResult).toFixed(3)}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Viikkotaulukko - koko leveys */}
        {staminaResult &&
          staminaResult.weeklyProgress &&
          staminaResult.weeklyProgress.length > 0 && (
            <div style={{ marginTop: '12px' }}>
              <Table
                striped
                bordered
                hover
                variant="dark"
                size="sm"
                style={{ fontSize: '0.75rem' }}
              >
                <thead>
                  <tr>
                    <th>{t('weekShort')}</th>
                    <th>{t('age')}</th>
                    <th>{t('skillLabel')}</th>
                    <th>{t('trainingAndDrop')}</th>
                    <th>{t('staminaLabel')}</th>
                    <th>{t('staminaShare')}</th>
                  </tr>
                </thead>
                <tbody>
                  {allWeeksData.map((week, idx) => (
                    <tr key={idx}>
                      <td>{week.week}</td>
                      <td>
                        {week.age?.[0]}v {week.age?.[1]}d
                      </td>
                      <td>
                        {week.trainingMode >= 2
                          ? taidot[week.trainingMode - 2] + ' '
                          : ''}
                        {(week.skillAfter ?? 0).toFixed(2)} (
                        <span
                          style={{
                            color:
                              (week.skillChange ?? 0) > 0
                                ? '#43b581'
                                : (week.skillChange ?? 0) < 0
                                ? '#f04747'
                                : '#99AAB5',
                          }}
                        >
                          {(week.skillChange ?? 0) >= 0 ? '+' : ''}
                          {(week.skillChange ?? 0).toFixed(2)}
                        </span>
                        )
                      </td>
                      <td>
                        <span style={{ color: '#43b581' }}>
                          +{(week.skillTraining ?? 0).toFixed(3)}
                        </span>
                        {(week.skillDrop ?? 0) < 0 && (
                          <>
                            {' / '}
                            <span style={{ color: '#f04747' }}>
                              {(week.skillDrop ?? 0).toFixed(3)}
                            </span>
                          </>
                        )}
                      </td>
                      <td>
                        {(week.staminaAfter ?? 0).toFixed(2)} (
                        <span
                          style={{
                            color:
                              (week.staminaChange ?? 0) >= 0
                                ? '#43b581'
                                : '#f04747',
                          }}
                        >
                          {(week.staminaChange ?? 0) >= 0 ? '+' : ''}
                          {(week.staminaChange ?? 0).toFixed(2)}
                        </span>
                        )
                      </td>
                      <td>{week.staminaShare ?? '-'}%</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
      </Card.Body>
    </Card>
  )
}

export default TrainButton
